import type { PanelFilterState } from './InstructorsFilterContext.types';

/**
 * Compares only the panel checkbox fields (disciplines, programs, locations).
 * Does NOT include searchText — use this to determine if panel filters changed.
 */
export function arePanelFiltersEqual(
  filters1: PanelFilterState,
  filters2: PanelFilterState
): boolean {
  return (
    areArraysEqual(filters1.disciplines, filters2.disciplines) &&
    areArraysEqual(filters1.programs, filters2.programs) &&
    areArraysEqual(filters1.locations, filters2.locations)
  );
}

function areArraysEqual(arr1: string[], arr2: string[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((value, index) => value === sorted2[index]);
}
